import { dataConstants } from 'services/redux/data/constants'
import { CalendarViewModes } from 'utils/constants/calendar-modes-constants'

export const localeSettingOptions = {
	YES: 'yes',
	NO: 'no'
}

export const localeSettingConstants = {
	BUILDING_FAVOURITES: 'building_favourites',
	FLOOR_FAVOURITES: 'floor_favourites',
	ROOM_FAVOURITES: 'room_favourites',
	
	
	CALENDAR_VIEW_MODE_BOOKINGS: 'calendar_mode_bookings'
};

export const localeSettingConstantsToState = {
	[ localeSettingConstants.BUILDING_FAVOURITES ]: dataConstants.BUILDING_FAVOURITES,
	[ localeSettingConstants.FLOOR_FAVOURITES ]: dataConstants.FLOOR_FAVOURITES,
	[ localeSettingConstants.ROOM_FAVOURITES ]: dataConstants.ROOM_FAVOURITES,
	
	[ localeSettingConstants.CALENDAR_VIEW_MODE_BOOKINGS ]: dataConstants.CALENDAR_VIEW_MODE_BOOKINGS,
};

export const localeSettingsDefaultValues = {
	[ localeSettingConstants.BUILDING_FAVOURITES ]: {},
	[ localeSettingConstants.FLOOR_FAVOURITES ]: {},
	[ localeSettingConstants.ROOM_FAVOURITES ]: {},
	
	[ localeSettingConstants.CALENDAR_VIEW_MODE_BOOKINGS ] : CalendarViewModes.WEEK
};
